/**
 * HUB.SMSRoute.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { RouteType } from './routeType';
import { RouteTypeName } from './routeTypeName';

export interface SmsRouteModel { 
    id?: string;
    routeGroupId?: string;
    aggregatorId?: string;
    routeImplementationId?: string;
    description?: string;
    routeName?: string;
    operatorCode?: string;
    routeType?: RouteType;
    routeTypeName?: RouteTypeName;
    status?: boolean;
    host?: string;
    port?: string;
    country?: string;
    countryCode?: string;
    mnc?: string;
    mcc?: string;
    dateCreated?: Date;
    tenantId?: string;
}